import { ClockTimestamp } from '@sqior/js/data';
import { OperationSpec, OperationType } from '@sqior/js/operation';

/** Sets the "server" time for this user session (for demo purposes only) */
export const DisplayTimePath = 'display-time';
export function SetDisplayTime(time: ClockTimestamp): OperationSpec<ClockTimestamp> {
  return { type: OperationType.Add, path: DisplayTimePath, data: time };
}
